import {
  type ClientOptions,
  createRpcClient,
  type InferRpcClient,
} from "@redotech/rpc/client";
import { rpcDefinition } from "./definition";

export function createRedoIntegrationsRpcClient(
  options: ClientOptions<typeof rpcDefinition>,
): InferRpcClient<typeof rpcDefinition> {
  return createRpcClient(rpcDefinition, options);
}

export type RedoIntegrationsRpcClient = ReturnType<
  typeof createRedoIntegrationsRpcClient
>;
